// extracted by mini-css-extract-plugin
module.exports = {"root":"Anchor_root__nhKfr"};